import "./MessageInfo.css";
import {
  Alert,
  Button,
  Card,
  Col,
  Layout,
  Modal,
  Row,
  Skeleton,
  Space,
  Tag,
  theme,
  Typography,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { BsInfo } from "react-icons/bs";
export const MessageInfo = ({ message }) => {
  return (
    <div className={"message-info-container"}>
      <div style={{ width: 100 }}>
        <div className={"message-info-icon"}>
          <BsInfo size={33} />
        </div>
      </div>
      <div>
        <p className={"message-info-text"}>{message}</p>
      </div>
    </div>
  );
};
